import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/site/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-brand-bone pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <Logo size={56} />
              <div>
                <p className="font-heading font-semibold text-lg">Guiding Support Services</p>
                <p className="text-[11px] uppercase tracking-[0.18em] text-brand-bone/60">Registered NDIS Provider</p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-brand-bone/70 max-w-xs">
              A registered NDIS provider delivering warm, person‑centred support across Australia.
            </p>
            <p className="mt-5 text-xs text-brand-bone/50">
              ABN 48 373 886 213
              <br />
              NDIS Provider ID 4‑000‑000‑000
            </p>
          </div>

          <div>
            <p className="font-heading text-sm uppercase tracking-[0.18em] text-brand-bone/60">Services</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                "Daily Personal Care",
                "Community Participation",
                "Supported Independent Living",
                "Household Tasks",
                "Transport Assistance",
                "Support Coordination",
              ].map((s) => (
                <li key={s}>
                  <a href="#services" data-testid={`footer-service-${s.toLowerCase().replace(/\s+/g, "-")}`} className="text-brand-bone/85 hover:text-brand-sage transition-colors">
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-heading text-sm uppercase tracking-[0.18em] text-brand-bone/60">Company</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                { label: "About", href: "#about" },
                { label: "How NDIS Works", href: "#how-it-works" },
                { label: "Stories", href: "#testimonials" },
                { label: "Service Areas", href: "#areas" },
                { label: "FAQ", href: "#faq" },
                { label: "Contact", href: "#contact" },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-brand-bone/85 hover:text-brand-sage transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-heading text-sm uppercase tracking-[0.18em] text-brand-bone/60">Contact</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-0.5 text-brand-sage" />
                <a href="tel:0413918449" data-testid="footer-phone" className="text-brand-bone/85 hover:text-brand-sage">0413 918 449</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-brand-sage" />
                <a href="mailto:joseph@guidingsupportservices.com" data-testid="footer-email" className="text-brand-bone/85 hover:text-brand-sage">joseph@guidingsupportservices.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-brand-sage" />
                <span className="text-brand-bone/85">Melbourne, VIC</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-bone/10 flex flex-col md:flex-row gap-4 md:items-center justify-between">
          <p className="text-xs text-brand-bone/55">© {year} Guiding Support Services. All rights reserved.</p>
          <p className="text-xs text-brand-bone/55">
            Acknowledging the Traditional Custodians of the lands on which we work. We pay our respects to Elders past and present.
          </p>
        </div>
      </div>
    </footer>
  );
}
